const iconModules = import.meta.glob(
  [
    './icons/taste/taste_icons_ui_png_centered/*.png',
  ],
  { eager: true, import: 'default', query: '?url' },
) as Record<string, string>

const iconFiles: Record<string, string> = {
  sweet: '01_tiantian.png',
  sour: '02_suansuan.png',
  bitter: '03_kuku.png',
  spicy: '04_lalala.png',
  salty: '05_xianxian_salty.png',
  umami: '06_xianxian_umami.png',
  plain: '07_dandan.png',
  rich: '08_nongyu.png',
  fresh: '09_qingshuang.png',
  warm: '10_nuannuan.png',
  fluffy: '11_mianmian.png',
  glutinous: '12_ruannuo.png',
  crisp: '13_susu.png',
  crunchy: '14_cuicui.png',
  silky: '15_sihua.png',
  aftertaste: '16_huigan.png',
  bracing: '17_qinglie.png',
  smoky: '18_yanxun.png',
  mellow: '19_chunhou.png',
  fruity: '20_guoxiang.png',
  milky: '21_naixiang.png',
  tea: '22_chaxiang.png',
  toasted: '23_jiaoxiang.png',
  aromatic_spice: '24_xinxiang.png',
  floral: '25_huaxiang.png',
  herbal: '26_caoben.png',
  cool: '27_liangliang.png',
}

const iconByFileName = Object.fromEntries(
  Object.entries(iconModules).map(([path, url]) => [path.split('/').pop() || '', url]),
)

export function getTasteIcon(code: string) {
  const fileName = iconFiles[code]
  return fileName ? iconByFileName[fileName] : undefined
}
